import { render, staticRenderFns } from "./Programa.vue?vue&type=template&id=6f970760"
import script from "./Programa.vue?vue&type=script&lang=js"
export * from "./Programa.vue?vue&type=script&lang=js"
import style0 from "./Programa.vue?vue&type=style&index=0&id=6f970760&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports